import { __extends } from "tslib";
import React from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { removeDeviations } from '../../actions';
import ItemControlButtons from '../ItemControlButtons';
var enhance = compose(connectMediaStore(null, { removeDeviations: removeDeviations }), withTranslation());
var CustomSetDeviationControlButtons = /** @class */ (function (_super) {
    __extends(CustomSetDeviationControlButtons, _super);
    function CustomSetDeviationControlButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDelete = function () {
            _this.props.removeDeviations([_this.props.deviation]);
        };
        return _this;
    }
    CustomSetDeviationControlButtons.prototype.render = function () {
        var className = this.props.className;
        return (React.createElement(ItemControlButtons, { className: className, withOneClickDelete: true, onDelete: this.onDelete }));
    };
    return CustomSetDeviationControlButtons;
}(React.Component));
export { CustomSetDeviationControlButtons };
export default enhance(CustomSetDeviationControlButtons);
//# sourceMappingURL=CustomSetDeviationControlButtons.connected.js.map